@if (editMode) {
  <span [formGroup]="formGroup">
    <mat-slide-toggle [(ngModel)]="toggleActive"></mat-slide-toggle>
  </span>
}

@if (!editMode) {
  <span>
    <mat-slide-toggle [disabled]="true" [(ngModel)]="toggleActive"></mat-slide-toggle>
  </span>
}
